import React from 'react';
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../../authConfig";
import { Link } from 'react-router-dom';
import './Login.css';

const Login = () => {
  const { instance } = useMsal();

  const handleLogin = () => {
    instance.loginRedirect(loginRequest).catch(e => {
      console.error("Login failed:", e);
    });
  };

  return (
    <div 
      className="login-container"
      style={{
        backgroundImage: `url(${process.env.PUBLIC_URL}/images/loginbg.png)`
      }}
    >
      <div className="login-navbar">
        <div className="navbar-brand">
          <img 
            src={`${process.env.PUBLIC_URL}/images/SAS_Logo.png`} 
            alt="SAS" 
            className="navbar-logo"
          />
          <span className="navbar-text">| SPIRIT AIR CARGO HANDLING</span>
        </div>
      </div>
      <div className="login-content">
        <div className="login-card">
          {/* <div className="card-header"> */}
            <img 
              src={`${process.env.PUBLIC_URL}/images/SAS_Logo.png`} 
              alt="SAS" 
              className="card-logo"
            />
            <h2 className="card-title">
              <span className="title-spirit">Spirit</span> <span className="title-cargo">Cargo</span>
            </h2>
          {/* </div> */}
          <button className="login-button" onClick={handleLogin}>
            SAS Employee Login
          </button>
          <p className="return-home-text">
            To return to homepage click <Link to="/" className="return-home-link">here</Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;
